export default __webpack_public_path__ + "static/media/flag-croatia.9bc445b9.svg";